<template>
	<div>
		<div class="company-info">
			<img
				:src="companyInfo.heading ? $imgUrl + companyInfo.heading : require('../../assets/image/login/logo.png')" />
			<div class="box">
				<span>{{companyInfo.name}}</span>
				<!-- <el-rate :v-model="5" disabled show-score text-color="#ff9900" score-template="{value}">
				</el-rate> -->
			</div>
			<el-button class="but" size="medium" type="warning" plain @click="openCustomerServer">在线留言</el-button>
		</div>
		<div class="section-tabs">
			<RentTabs :tabsList="typeList" @active="typeChange"></RentTabs>
			<RentTabs :tabsList="dianya" tabType="电压" @active="dianyaChange"></RentTabs>
			<RentTabs :tabsList="rongliang" tabType="容量" @active="rongliangChange"></RentTabs>
			<RentTabs :tabsList="paixu" :isBorder="false" tabType="排序" @active="paixuChange"></RentTabs>
		</div>
		<div class="content">
			<div class="center flex-row wrap">
				<div v-for="(item, i) in equipmentList" :key="i" class="card-item">
					<HomeListCard :detail="item" :type="item.serviceType" :changeEq="changeEq"></HomeListCard>
				</div>
			</div>
		</div>
		<div style="display: flex; justify-content: center; background-color: #f5f5f5" :v-if="total > 0">
			<el-pagination background layout="prev, pager, next,total" :total="total" :page-size="query.pageSize"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import RentTabs from "../../components/rentTabs.vue";
	import HomeListCard from "../../components/homeListCard.vue";
	import {
		equipmentTypeApi,
		equipmentListApi
	} from "../../http/api/ordinary.js";
	import {
		equipmentVolumeApi,
		equipmentVoltageApi,
	} from "../../http/factory/add-eme.js";
	export default {
		components: {
			RentTabs,
			HomeListCard,
		},
		data() {
			return {
				typeList: [{
					key: null,
					value: "不限",
				}, ],
				dianya: [{
					key: null,
					value: "不限",
				}, ],
				rongliang: [{
					key: null,
					value: "不限",
				}, ],
				paixu: [{
						key: null,
						value: "不限",
					},
					{
						key: 1,
						value: "销量",
					},
					{
						key: 2,
						value: "价格",
					},
					{
						key: 3,
						value: "评分",
					},
				],
				equipmentList: [],
				query: {
					pageSize: 15,
					pageNum: 1,
					typeId: null,
					voltageId: null,
					volumeId: null,
				},
				total: 0,
				companyInfo: {

				},
				changeEq: 0,
				serviceType: 0
			};
		},
		created() {
			this.init();
			this.getEquipmentList();

		},
		methods: {
			init() {
				this.companyInfo = JSON.parse(this.$route.query.object)
				this.changeEq = this.$route.query.changeEq
				if (this.$route.query.serviceType != null) {
					this.serviceType = 1
				}
				//设备类型
				equipmentTypeApi({
					serviceType: this.serviceType
				}).then((res) => {
					for (let item of res) {
						this.typeList.push({
							key: item.id,
							value: item.name,
						});
					}
				});
				//容量
				equipmentVolumeApi({
					serviceType: this.serviceType
				}).then((res) => {
					for (let item of res) {
						this.rongliang.push({
							key: item.id,
							value: item.volume,
						});
					}
				});
				//电压
				equipmentVoltageApi({
					serviceType: this.serviceType
				}).then((res) => {
					for (let item of res) {
						this.dianya.push({
							key: item.id,
							value: item.voltage,
						});
					}
				});
			},
			getEquipmentList() {
				this.query.customerId = this.companyInfo.id
				this.query.serviceType = this.serviceType
				equipmentListApi(this.query).then((res) => {
					this.equipmentList = res.rows;
					this.total = res.total;
				});
			},
			handleCurrentChange(val) {
				this.query.pageNum = val;
				this.getEquipmentList();
			},
			typeChange(id) {
				this.query.typeId = id;
				this.getEquipmentList();
			},
			dianyaChange(id) {
				this.query.voltageId = id;
				this.getEquipmentList();
			},
			rongliangChange(id) {
				this.query.volumeId = id;
				this.getEquipmentList();
			},
			paixuChange(id) {
				this.query.paixu = id;
				this.getEquipmentList();
			},
			openCustomerServer() {
				this.$router.push({
					path: '/service',
					query: {
						contactType: 1,
						contactId: this.companyInfo.id
					}
				})
			},
		},
	};
</script>

<style lang="less" scoped>
	.company-info {
		background-color: #fff;
		display: flex;
		justify-content: start;
		padding: 30px 2.5rem;

		img {
			width: 80px;
			height: 80px;
		}

		.box {
			font-size: 18px;
			margin-left: 20px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.but {
			margin-left: auto;
			height: 40px;
		}
	}

	.img-top {
		height: 2.1rem;
		background-color: #c4c4c4;
		background-image: url("../../assets/image/tingdian.png");
		background-size: 100% 100%;
		padding: 0.59rem 0 0 2rem;
		-webkit-box-sizing: border-box;
	}

	.text-title {
		font-size: 0.3rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		line-height: 0.42rem;
		margin-bottom: 0.14rem;
		font-style: italic;
		letter-spacing: 0.02rem;
	}

	.text-subtitle {
		font-size: 0.16rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #ffffff;
		line-height: 0.22rem;
		font-style: italic;
		letter-spacing: 0.01rem;
	}

	.section-tabs {
		padding: 0 2rem;
		background: #ffffff;
	}

	.content {
		background: #f5f5f5;
		padding-bottom: 0.47rem;
	}

	.center {
		width: 15.19rem;
		margin: 0 auto;
		padding-top: 0.2rem;
	}

	.card-item {
		margin-bottom: 0.06rem;
	}

	.fenye {
		margin-top: 0.4rem;
	}
</style>
